/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedTaxStandardRequestDto } from '../../models/backend-patched-tax-standard-request-dto';
import { BackendTaxStandardDto } from '../../models/backend-tax-standard-dto';

export interface ProjectTaxesTaxStandardPartialUpdate$FormData$Params {
  id: number;
  body?: BackendPatchedTaxStandardRequestDto;
}

export function projectTaxesTaxStandardPartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: ProjectTaxesTaxStandardPartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendTaxStandardDto>> {
  const rb = new RequestBuilder(rootUrl, projectTaxesTaxStandardPartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendTaxStandardDto>;
    }),
  );
}

projectTaxesTaxStandardPartialUpdate$FormData.PATH = '/api/project_taxes/tax_standard/{id}/';
